import { alertsConstants } from '../constants/alerts';
import { webmaster } from '../services/ApiService';

export const openAlert = (params) => ({
  type: alertsConstants.OPEN_ALERT,
  params,
});

export const closeAlert = id => ({
  type: alertsConstants.CLOSE_ALERT,
  id,
});

export const deleteMessage = id => dispatch => {
  return dispatch({
    type: alertsConstants.MESSAGE_HAS_BEEN_READ,
    id
  });
};

export const closeMessage = id => dispatch => {
  return webmaster.readMessage({id}).then(() => dispatch(deleteMessage(id)));
};

export const setMessages = (messages = []) => ({
  type: alertsConstants.SET_MESSAGES,
  messages
});
